import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BarcodeReader from "react-barcode-reader";
import Select from "react-select";
import { Calendar } from "react-datepicker2";
import { formatDate, formatNumber, formatPrice } from "../../helpers";
import { findValue, getOptions, updateInput } from "./functions";
import { RenderInput } from "./render";
import { appSetModal, setConfirm } from "../../store/actions/appAction";
import {
  apiAddPersonCategory,
  apiAddProductCategory,
  apiDeletePersonCategory,
  apiDeleteProductCategory,
  apiGetPersonCategories,
  apiGetProductCategories,
  apiUpdatePersonCategory,
  apiUpdateProductCategory,
} from "../../api/categoryApi";

import TreeSelectBox from "../simple/TreeSelectBox";
import ImagePicker from "../simple/ImagePicker";
import TrueFalse from "../simple/TrueFalse";
import Status from "../simple/Status";

import ActiveArrowCurrency from "../../assets/svg/currency-arrow-bottom-active.svg";
import AddUnitPlus from "../../assets/svg/add-unit-plus.svg";
import ArrowCurrency from "../../assets/svg/currency-arrow-bottom.svg";
import CloseIconInputs from "../../assets/svg/close-icon-inputs.svg";
import iconUp from "../../assets/svg/icon-up.svg";
import imgDatePicker from "../../assets/svg/date-picker.svg";
import SearchIcon from "../../assets/svg/serach-select-box-tree.svg";
import bookMarkFactorWhite from "../../assets/svg/bookMarkFactorWhite.svg";

import "../../assets/styles/components/datePicker.scss";
import "../../assets/styles/components/currency.scss";
import "../../assets/styles/components/tabForms.scss";
import "../../assets/styles/components/radioInput.scss";
import "../../assets/styles/components/secondaryUnit.scss";
import "../../assets/styles/productServices/addProduct.scss";
import "../../assets/styles/shareholder/shareholder.scss";
import "../../assets/styles/components/switchBox.scss";
import "../../assets/styles/components/newInput.scss";
import { useNavigate } from "react-router-dom";
import { apiChangePassword } from "../../api/appApi";
import iconLoading from "../../assets/svg/icon-loading.svg";
import {
  apiAddAccountingType,
  apiDeleteAccountingType,
  apiGetAccountingTypes,
  apiUpdateAccountingType,
} from "../../api/accountingTypeApi";
import momentJalaali from "moment-jalaali";
import { Checkbox } from "@mui/material";
import getCurrency from "helpers/currencyHelper";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import useCurrency from "helpers/useCurrency";
import { set } from "react-hook-form";

const secretViewValue = "******";

export const SelectBox = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const defaultValue = input.defaultValue ?? "";
  const options = getOptions(input.options, state);
  const formType = input.formType ?? "forms";

  const permissions = useSelector((state) => state).permissionReducer.permissions;

  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);

  const updateValue = () => {
    let value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );

    if (editItem) {
      value = options.find((o) => o.id === (value?.id ?? value));
    }

    setValue(value);
    updateInput(dispatch, input.formType, input.name, value, input.primary);
  };

  const onChange = (value) => {
    setValue(value);
    if (formData.page === "warehouse" && input.name === "branch") {
      updateInput(dispatch, input.formType, "BranchId", value.id, input.primary)
    }
    updateInput(dispatch, input.formType, input.name, value, input.primary);

    if (input.onChange) {
      input.onChange(dispatch, value, permissions);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: 30,
      height: 32,
      borderColor: "#c5c5c5",
      borderRadius: 5,
      marginTop: 2,
      marginBottom: 2,
      fontSize: 12,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      marginTop: -2,
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: 6,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),
  };

  return (
    <>
      {input.label == null ? (
        <></>
      ) : (
        <label className="label-wrap-new-input d-flex justify-content-between align-content-center">
          <span>{input.label + (input.required ? " *" : "")}</span>
          {input.addModal && (
            <span
              className="small"
              style={{ cursor: "pointer", color: "#1062D0" }}
              onClick={() => {
                dispatch(appSetModal({ ...input.addModal.props }));
              }}
            >
              + افزودن
            </span>
          )}
        </label>
      )}
      {/*<div className={input.wrapperClass ?? ""}>*/}
      <div>
        <Select
          styles={customStyles}
          isRtl={true}
          isMulti={input.multiple ?? false}
          placeholder={secretView ? secretViewValue : input.label}
          options={options}
          value={secretView ? secretViewValue : value}
          onChange={(value) => {
            onChange(value);
          }}
          onKeyDown={(event) => {
            const key = event.key;
            if (key === "Backspace" || key === "Delete") {
              onChange(undefined);
            }
          }}
          noOptionsMessage={({ inputValue }) => (!inputValue ? "نتیجه ای پیدا نشد" : "نتیجه ای پیدا نشد")}
        />
      </div>
    </>
  );
};

export const TextInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const showLabel = props.showLabel ?? true;
  const disabled = props.disabled ?? false;
  const defaultValue = editItem ? editItem[input.name] : input.defaultValue ?? "";
  const formType = input.formType ?? "forms";
  const numberOnly = input.numberOnly;

  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setValue(value);
    if (editItem) {
      updateInput(dispatch, input.formType, input.name, value, input.primary);
    }
  };

  const onChange = (value) => {
    if (numberOnly) {
      if (isNaN(value)) return;
    }

    if (value.length > 0) {
      value = displayValue(value);
      if (typeof value === "string") value = value.replaceAll(",", "");
      if (input.parseInt) {
        value = parseInt(value);
      }
    }
    updateInput(dispatch, input.formType, input.name, value, input.primary);
    setValue(value);
  };

  const displayValue = (value) => {
    if (!value) return "";
    if (input.type && input.type === "number") {
      return formatNumber(value);
    } else if (input.type && input.type === "price") {
      return formatPrice(value);
    }
    return value;
  };

  return (
    <>
      {input.label == null || !showLabel ? (
        <></>
      ) : (
        <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
      )}
      <div className={disabled ? "disabled-wrap-new-input" : "wrap-new-input"}>
        <input
          className="c-new-input"
          placeholder={input.placeholder}
          disabled={disabled}
          type={input.isPassword ? "password" : "text"}
          value={secretView ? secretViewValue : disabled ? "" : displayValue(value)}
          maxLength={input.maxLength ?? -1}
          onChange={(e) => onChange(e?.currentTarget?.value)}
        />
      </div>
    </>
  );
};

export const BarcodeInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const showLabel = props.showLabel ?? true;
  const disabled = props.disabled ?? false;
  const defaultValue = editItem ? editItem[input.name] : input.defaultValue ?? "";
  const formType = input.formType ?? "forms";

  const [value, setValue] = useState(defaultValue);
  const [auto, setAuto] = useState(false);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setValue(value);

    if (editItem) {
      updateInput(dispatch, input.formType, input.name, value, input.primary);
    }
  };

  const onChange = (value) => {
    updateInput(dispatch, input.formType, input.name, value, input.primary);
    setValue(value);
  };

  return (
    <>
      {input.label == null || !showLabel ? (
        <></>
      ) : (
        <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
      )}

      <BasicTextInput
        required={input.required}
        placeholder={input.placeholder}
        disabled={disabled || auto}
        val={secretView ? secretViewValue : disabled || auto ? "" : value}
        maxLength={input.maxLength ?? -1}
        onChange={onChange}
      />
      <BarcodeReader
        onError={(err) => console.log(err)}
        onScan={(barcode) => {
          const barcodes = value ? value.split(";") : [];
          if (!barcodes.includes(barcode)) {
            onChange(`${value ?? ""}${barcode};`);
          }
        }}
      />
      {/*{!editItem && (*/}
      <div
        className="flex items-center cursor-pointer"
        onClick={() => {
          if (!auto) {
            setValue("auto");
            onChange("auto");
          } else {
            setValue(undefined);
            onChange(undefined);
          }
          setAuto((x) => !x);
        }}
      >
        <Checkbox checked={auto} />
        <span className="text-xs whitespace-nowrap">{input.autoCheckLabel}</span>
      </div>
      {/*)}*/}
    </>
  );
};

export const TextAreaInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const showLabel = props.showLabel ?? true;
  const disabled = props.disabled ?? false;
  const defaultValue = editItem ? editItem[input.name] : input.defaultValue ?? "";
  const formType = input.formType ?? "forms";
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, [value]);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  // useEffect(() => {
  //   updateValue();
  // }, [formData[input.formType][input.name]]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setValue(value);

    if (editItem) {
      updateInput(dispatch, input.formType, input.name, value, input.primary);
    }
  };

  const onChange = (value) => {
    updateInput(dispatch, input.formType, input.name, value, input.primary);
    setValue(value);
  };

  return (
    <>
      {input.label == null || !showLabel ? (
        <></>
      ) : (
        <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
      )}
      <div className={disabled ? "disabled-wrap-new-input" : "wrap-new-input"} style={{ height: "auto" }}>
        <textarea
          className="c-new-input"
          rows={input.rows ?? 10}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          value={secretView ? secretViewValue : value}
        ></textarea>
      </div>
    </>
  );
};

export const PersonTypeInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const showLabel = props.showLabel ?? true;
  const disabled = props.disabled ?? false;
  const defaultPersonType = input.defaultValue ?? "حقیقی";
  const defaultValue = "";
  const formType = input.formType ?? "forms";

  const [selectedPersonType, setSelectedPersonType] = useState(defaultPersonType);
  const [firstName, setFirstName] = useState(defaultValue);
  const [lastName, setLastName] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);

  useEffect(() => {
    updateValue();
    if (editItem) {
      const personType = editItem["isLegal"] ?? defaultValue;
      setSelectedPersonType(personType);
      updateInput(dispatch, input.formType, "isLegal", personType, false);
    }
  }, [editItem]);

  const updateValue = () => {
    const personType = findValue(
      formData,
      input.formType,
      "isLegal",
      editItem ? editItem["isLegal"] : defaultPersonType
    );
    const firstName = findValue(
      formData,
      input.formType,
      "firstName",
      editItem ? editItem["firstName"] : defaultValue
    );
    const lastName = findValue(
      formData,
      input.formType,
      "lastName",
      editItem ? editItem["lastName"] : defaultValue
    );

    setSelectedPersonType(personType);
    setFirstName(firstName);
    setLastName(lastName);
    updateInput(dispatch, input.formType, "isLegal", personType, false);
  };

  const onChange = (value, type) => {
    if (type === "firstName") {
      setFirstName(value);
    } else if (type === "lastName") {
      setLastName(value);
    }

    updateInput(dispatch, input.formType, type, value, input.primary);
  };

  const changeSelectedPersonType = () => {
    if (selectedPersonType === "حقیقی") {
      setSelectedPersonType("حقوقی");
      updateInput(dispatch, input.formType, "isLegal", "حقوقی", false);
    } else {
      setSelectedPersonType("حقیقی");
      updateInput(dispatch, input.formType, "isLegal", "حقیقی", false);
    }
  };

  if (selectedPersonType === "حقیقی") {
    return (
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12">
          <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
          <div
            className={
              disabled ? "disabled-wrap-new-input wrap-new-input-row" : "wrap-new-input wrap-new-input-row"
            }
          >
            <div className="border-0 person-type-select w-100" onClick={changeSelectedPersonType}>
              <span>{secretView ? secretViewValue : selectedPersonType}</span>
              <div className="person-type-icon-wrapper">
                <img className="arrow-bottom-select-box-input" src={iconUp} alt="iconUp" />
                <img className="rotate-180 arrow-bottom-select-box-input" src={iconUp} alt="iconUp" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <label className="label-wrap-new-input">نام</label>
          <div
            className={
              disabled ? "disabled-wrap-new-input wrap-new-input-row" : "wrap-new-input wrap-new-input-row"
            }
          >
            <input
              onChange={(e) => onChange(e.target.value, "firstName")}
              value={secretView ? secretViewValue : firstName}
              className="c-new-input"
              disabled={disabled}
              name="firstName"
              maxLength={64}
              placeholder={input.placeholder}
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <label className="label-wrap-new-input">نام خانوادگی</label>
          <div
            className={
              disabled ? "disabled-wrap-new-input wrap-new-input-row" : "wrap-new-input wrap-new-input-row"
            }
          >
            <input
              onChange={(e) => onChange(e.target.value, "lastName")}
              value={secretView ? secretViewValue : lastName}
              className="c-new-input"
              disabled={disabled}
              name="lastName"
              maxLength={64}
              placeholder={input.placeholder}
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="flex-row d-flex">
        <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
        <label className="mx-4 pe-2 label-wrap-new-input">نام شرکت</label>
      </div>
      <div
        className={
          disabled ? "disabled-wrap-new-input wrap-new-input-row" : "wrap-new-input wrap-new-input-row"
        }
      >
        <div className="person-type-select" onClick={changeSelectedPersonType}>
          <span>{secretView ? secretViewValue : selectedPersonType}</span>
          <div className="person-type-icon-wrapper">
            <img className="arrow-bottom-select-box-input" src={iconUp} alt="iconUp" />
            <img className="rotate-180 arrow-bottom-select-box-input" src={iconUp} alt="iconUp" />
          </div>
        </div>
        <input
          onChange={(e) => onChange(e.target.value, "firstName")}
          value={secretView ? secretViewValue : firstName}
          className="c-new-input pe-1"
          disabled={disabled}
          name="firstName"
          maxLength={64}
          placeholder={input.placeholder}
        />
      </div>
    </>
  );
};

export const ImagePickerInput = (props) => {
  return props.input.active ? (
    <div className={props.input.wrapperClass}>
      <div className="img-uploader">
        <ImagePicker input={props.input} />
      </div>
    </div>
  ) : null;
};

export const AccountingCodeInput = (props) => {
  const [active, setActive] = useState(false);

  return (
    <div
      className={props.input.wrapperClass ?? "col-lg-7 col-md-7 col-sm-7 col-xs-12"}
      style={props.input.style ?? null}
    >
      <div className="box-true-false">
        <div>
          <TrueFalse input={props.input} active={active} setActive={setActive} />
        </div>
        <div>
          <TextInput input={props.input} showLabel={false} disabled={active} />
        </div>
      </div>
    </div>
  );
};

export const StatusInput = (props) => {
  return props.input.active ? (
    <div className={props.input.wrapperClass}>
      <Status input={props.input} />
    </div>
  ) : null;
};

export const OptionalDescription = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const defaultValue = input.active ?? false;
  const formType = input.formType ?? "forms";

  const [active, setActive] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);

  useEffect(() => {
    if (!active) {
      updateInput(dispatch, input.formType, input.name, null, input.primary);
    }
  }, [active]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setActive(value);
  };

  return active ? (
    <>
      <img
        onClick={() => setActive(false)}
        className="img-close-icon-inputs"
        src={CloseIconInputs}
        alt="CloseIconInputs"
      />
      <TextInput input={input} />
    </>
  ) : (
    <div className="text-add-desc" onClick={() => setActive(true)}>
      {input.label ?? "افزودن توضیحات"}
    </div>
  );
};

export const CurrencyInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const currencies = useSelector((state) => state).currencyReducer.currencies;
  const otherCurrencies = useSelector((state) => state).currencyReducer.businessCurrencies;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const business = useSelector((state) => state.businessReducer.business.business);
  const currencyInputName = `${input.name}Currency`;
  const businessCurrencies = [
    currencies.find((c) => c.id === business.default_currency_id),
    ...otherCurrencies,
  ];
  const defaultValue = input.defaultValue ?? "";
  const defaultCurrency = input.defaultCurrency ?? businessCurrencies[0];
  const formType = input.formType ?? "forms";

  const [value, setValue] = useState(defaultValue);
  const [currency, setCurrency] = useState(businessCurrencies[0] ?? defaultCurrency);
  const [selectCurrency, setSelectCurrency] = useState(false);
  const { defCur } = useCurrency();

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);

  const updateValue = () => {
    const currency = findValue(
      formData,
      input.formType,
      currencyInputName,
      editItem ? editItem[currencyInputName] ?? defaultCurrency : defaultCurrency
    );
    const currencyValue = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setCurrency(currency);
    setValue(currencyValue);
    updateInput(
      dispatch,
      input.formType,
      input.name,
      currencyValue ? currencyValue.toString().replaceAll(",", "") : null,
      input.primary
    );
    updateInput(dispatch, input.formType, currencyInputName, currency, input.primary);
  };

  return (
    <BasicTextInput
      label={input.label}
      type="price"
      prefix={<div className="text-dark-3">{defCur.en_title}</div>}
      onChange={(val) => {
        updateInput(dispatch, input.formType, input.name, val, input.primary);
        setValue(val);
      }}
      val={value}
      placeHolder={input.placeholder}
    />
  );
};

export const AddableSelectBox = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editData = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const categories = useSelector((state) => state).categoryReducer[input.categoryType] ?? [];
  const token = useSelector((state) => state).businessReducer.business.token;
  const defaultValue = input.defaultValue ?? null;

  const [selectBoxValue, setSelectBoxValue] = useState(defaultValue);
  const [showSelectBoxTree, setShowSelectBoxTree] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const [searchText, setSearchText] = useState("");
  const [searchItems, setSearchItems] = useState([]);

  useEffect(() => {
    if (input.categoryType === "personCategories") {
      dispatch(apiGetPersonCategories(token));
    } else if (input.categoryType === "productCategories") {
      dispatch(apiGetProductCategories(token));
    } else if (input.categoryType === "serviceCategories") {
      dispatch(apiGetProductCategories(token, false));
    }
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editData]);

  const updateValue = () => {
    if (editData && editData[input.name]) {
      findCategory(editData[input.name], categories);
    } else {
      const value = findValue(formData, input.formType, input.name, defaultValue);
      setSelectBoxValue(value);
    }
  };

  const findCategory = (id, categories) => {
    if (categories) {
      categories.map((c) => {
        if (id === c.id) {
          setSelectBoxValue(c);
          updateInput(dispatch, input.formType, input.name, c, input.primary);
        } else {
          findCategory(id, c.childs);
        }
      });
    }
  };

  const filterItems = (categories, filteredCategories, searchText) => {
    categories.map((c) => {
      if (c.title.includes(searchText)) {
        filteredCategories.push(c);
      }

      if (c.childs && c.childs.length > 0) {
        filterItems(c.childs, filteredCategories, searchText);
      }
    });

    setSearchItems(filteredCategories);
  };

  const toggleSelectBoxTree = () => {
    setShowSelectBoxTree(!showSelectBoxTree);
  };

  const selectItem = (item) => {
    setEditingItem(null);
    setSelectBoxValue(item);
    updateInput(dispatch, input.formType, input.name, item, input.primary);
    toggleSelectBoxTree();
  };

  const editItem = (item) => {
    setSelectBoxValue(item);
    setEditingItem(item);
  };

  const addItem = () => {
    const category = {
      id: editingItem.id ?? null,
      title: editingItem.title ?? editingItem,
      parentId: editingItem?.parentId ?? null,
    };

    if (input.categoryType === "personCategories") {
      if (editingItem.id) {
        dispatch(apiUpdatePersonCategory(category, token));
      } else {
        dispatch(apiAddPersonCategory(category, token));
      }
    } else if (input.categoryType === "productCategories") {
      if (editingItem.id) {
        dispatch(apiUpdateProductCategory(category, token));
      } else {
        dispatch(apiAddProductCategory(category, token));
      }
    } else if (input.categoryType === "serviceCategories") {
      if (editingItem.id) {
        dispatch(apiUpdateProductCategory(category, token, false));
      } else {
        dispatch(apiAddProductCategory(category, token, false));
      }
    }
    setEditingItem(null);
  };

  const deleteItem = (item) => {
    let callback = null;
    if (input.categoryType === "personCategories") {
      callback = () => {
        dispatch(apiDeletePersonCategory(item.id, token));
      };
    } else if (input.categoryType === "productCategories") {
      callback = () => {
        dispatch(apiDeleteProductCategory(item.id, token));
      };
    } else if (input.categoryType === "serviceCategories") {
      callback = () => {
        dispatch(apiDeleteProductCategory(item.id, token, false));
      };
    }
    dispatch(setConfirm("دسته بندی", callback));
  };

  return (
    <div className="warp-select-box-tree">
      {input.label == null ? (
        <></>
      ) : (
        <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
      )}
      <div
        onClick={() => toggleSelectBoxTree()}
        className={showSelectBoxTree ? "active-wrap-new-select-box-tree" : "wrap-new-select-box-tree"}
      >
        <img className="arrow-select-box-tree" src={ArrowCurrency} alt="ArrowCurrency" />
        <img className="arrow-select-box-tree-active" src={ActiveArrowCurrency} alt="ActiveArrowCurrency" />
        <input
          onChange={(e) => setSelectBoxValue(selectBoxValue)}
          className="c-new-select-box-tree"
          value={secretView ? secretViewValue : selectBoxValue ? selectBoxValue.title : ""}
          maxLength="16"
        />
      </div>
      {showSelectBoxTree ? (
        <div className="select-tree-show">
          <div className="search-box-selecet-tree">
            <input
              className="input-search-select-box-tree"
              type="text"
              placeholder="جستجو"
              maxLength="16"
              value={secretView ? secretViewValue : searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                filterItems(categories, [], e.target.value);
              }}
            />
            <img className="img-serach-select-box-tree" src={SearchIcon} alt="SearchIcon" />
          </div>
          <div className="data-select-box-tree">
            <TreeSelectBox
              input={input}
              depth={2}
              items={searchText.length > 1 ? searchItems : categories}
              selectItem={selectItem}
              editItem={editItem}
              addItem={addItem}
              deleteItem={deleteItem}
              value={secretView ? secretViewValue : selectBoxValue}
              editingItem={editingItem}
              setEditingItem={setEditingItem}
            />
          </div>
          {/* <div className="footer-select-box-tree"> */}
          {/* <div /> */}
          {/*<div*/}
          {/*    className="text-add-item-select-box-tree"*/}
          {/*    onClick={() => setEditingItem({})}*/}
          {/*>*/}
          {/*    افزودن دسته بندی*/}
          {/*</div>*/}
          {/* <div>
              <button className="cancel-add-select-box-tree" onClick={() => toggleSelectBoxTree()}>
                انصراف
              </button>
              <button className="select-add-select-box-tree" onClick={() => toggleSelectBoxTree()}>
                انتخاب
              </button>
            </div> */}
          {/* </div> */}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export const AccountingTypesTable = (props) => {
  const { input, value } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editData = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const accountingTypes = useSelector((state) => state).accountingReducer.accountingTypes ?? [];
  const token = useSelector((state) => state).businessReducer.business.token;
  const defaultValue = input.defaultValue ?? null;
  const type = input.options;
  const formType = input.formType ?? "forms";

  const [selectBoxValue, setSelectBoxValue] = useState(props.value ?? defaultValue);
  const [showSelectBoxTree, setShowSelectBoxTree] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const [searchText, setSearchText] = useState("");
  const [searchItems, setSearchItems] = useState([]);
  const data = props.data || accountingTypes[type];

  useEffect(() => {
    getAccountTypes();
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editData, value]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);

  const getAccountTypes = () => {
    dispatch(apiGetAccountingTypes(token, type, updateValue));
  };

  const updateValue = () => {
    if (props.value) {
      findCategory(props.value.id, data ? data.childs : accountingTypes.childs);
    } else {
      const value = props.value ?? input.accounting ?? null;
      setSelectBoxValue(value);
    }
  };

  const findCategory = (id, accountingTypes) => {
    if (accountingTypes) {
      accountingTypes.map((c) => {
        if (id === c.id) {
          setSelectBoxValue(c);
          updateInput(dispatch, input.formType, input.name, c, input.primary);
        } else {
          findCategory(id, c.childs);
        }
      });
    }
  };

  const filterItems = (accountingTypes, filteredAccountingTypes, searchText) => {
    accountingTypes.map((c) => {
      if (c.title.includes(searchText)) {
        filteredAccountingTypes.push(c);
      }

      if (c.childs && c.childs.length > 0) {
        filterItems(c.childs, filteredAccountingTypes, searchText);
      }
    });

    setSearchItems(filteredAccountingTypes);
  };

  const toggleSelectBoxTree = () => {
    setShowSelectBoxTree(!showSelectBoxTree);
  };

  const selectItem = (item) => {
    setEditingItem(null);
    setSelectBoxValue(item);
    // updateInput(dispatch, input.formType, input.name, item, input.primary);
    toggleSelectBoxTree();
    props.onChange(input.index, input.key, item);
  };

  const editItem = (item) => {
    setSelectBoxValue(item);
    setEditingItem(item);
  };

  const addItem = () => {
    const accountingType = {
      id: editingItem.id ?? null,
      title: editingItem.title ?? editingItem,
      parentId: editingItem?.parentId ?? null,
      accountingCode: editingItem?.accountingCode ?? null,
    };

    if (editingItem.id) {
      dispatch(apiUpdateAccountingType(accountingType, token, getAccountTypes));
    } else {
      dispatch(apiAddAccountingType(accountingType, token, getAccountTypes));
    }

    setEditingItem(null);
  };

  const deleteItem = (item) => {
    let callback = () => {
      dispatch(apiDeleteAccountingType(item.id, token, getAccountTypes));
    };

    dispatch(setConfirm("حساب", callback));
  };

  return (
    <div className="warp-select-box-tree" style={{ width: `${input.size}%` }}>
      {input.label == null ? (
        <></>
      ) : (
        <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
      )}
      <div
        onClick={() => toggleSelectBoxTree()}
        className={showSelectBoxTree ? "active-wrap-new-select-box-tree" : "wrap-new-select-box-tree"}
        style={{ border: 0 }}
      >
        <img className="arrow-select-box-tree" src={ArrowCurrency} alt="ArrowCurrency" />
        <img className="arrow-select-box-tree-active" src={ActiveArrowCurrency} alt="ActiveArrowCurrency" />
        <input
          onChange={(e) => setSelectBoxValue(selectBoxValue)}
          onKeyDown={(event) => {
            const key = event.key;
            if (key === "Backspace" || key === "Delete") {
              setSelectBoxValue(null);
              props.onKeyDown(event);
            }
          }}
          className="c-new-select-box-tree"
          value={selectBoxValue?.title}
          maxLength="32"
        />
      </div>
      {showSelectBoxTree ? (
        <div className="select-tree-show">
          <div className="search-box-selecet-tree">
            <input
              className="input-search-select-box-tree"
              type="text"
              placeholder="جستجو"
              maxLength="16"
              value={secretView ? secretViewValue : searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                filterItems([data], [], e.target.value);
              }}
            />
            <img className="img-serach-select-box-tree" src={SearchIcon} alt="SearchIcon" />
          </div>
          <div className="data-select-box-tree">
            <TreeSelectBox
              accounting={true}
              input={input}
              depth={2}
              items={searchText.length > 1 ? searchItems : [data]}
              selectItem={selectItem}
              editItem={editItem}
              addItem={addItem}
              deleteItem={deleteItem}
              value={secretView ? secretViewValue : selectBoxValue}
              editingItem={editingItem}
              setEditingItem={setEditingItem}
            />
          </div>
          <div className="footer-select-box-tree">
            <div />
            {/*{*/}
            {/*    input.editable*/}
            {/*        ?*/}
            {/*        <div*/}
            {/*            className="text-add-item-select-box-tree"*/}
            {/*            onClick={() => setEditingItem({})}*/}
            {/*        >*/}
            {/*            افزودن دسته بندی*/}
            {/*        </div>*/}
            {/*        : <div></div>*/}
            {/*}*/}
            <div>
              <button className="cancel-add-select-box-tree" onClick={() => toggleSelectBoxTree()}>
                انصراف
              </button>
              <button className="select-add-select-box-tree" onClick={() => toggleSelectBoxTree()}>
                انتخاب
              </button>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export const FormTypeSelectionInput = (props) => {
  const { form, activeTab, setActiveTab } = props;
  const checkEditItem = props.checkEditItem ?? true;
  const editItem = useSelector((state) => state.formReducer.editItem);

  useEffect(() => {
    if (!activeTab) {
      let tab = form.tabs[0].key;
      setActiveTab(tab);
    }
  }, []);

  useEffect(() => {
    if (checkEditItem && editItem && (editItem.formTab || editItem.type || editItem.formType)) {
      setActiveTab(editItem.formTab ?? editItem.type ?? editItem.formType);
    }
  }, [editItem]);

  return (
    <div className="header-inputs-page">
      <div className="text-header-inputs">
        {form.tabs.length > 1 ? `نوع ${form.title}` : form.tabs[0].name}
      </div>
      {form.tabs.length > 1 ? (
        <div className="warp-tabs-form">
          <div className="tab-pages">
            {form.tabs.map((item) => {
              return (
                <div
                  key={item.name}
                  className={item.key === activeTab ? "active-item-tab-pages" : "item-tab-pages"}
                  onClick={() => setActiveTab(item.key)}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export const Divider = (props) => {
  return (
    <div
      className={
        props.input.wrapperClass ??
        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative"
      }
    />
  );
};

export const AddUnit = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const updateFlag = useSelector((state) => state).formReducer.updateFlag;
  const defaultValue = input.defaultValue ?? false;

  const [secondUnit, setSecondUnit] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, updateFlag, editItem]);

  useEffect(() => {
    setSecondUnit(true);
    updateInput(dispatch, input.formType, input.name, true, input.primary, !updateFlag);
  }, [editItem]);

  const updateValue = () => {
    const value = findValue(formData, input.formType, input.name, defaultValue);
    setSecondUnit(value);
  };

  const onChange = () => {
    updateInput(dispatch, input.formType, input.name, true, input.primary, !updateFlag);
    setSecondUnit(true);
  };

  return (
    <>
      <div
        className={
          input.wrapperClass + " " + "style-add-unit" ?? "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-add-unit"
        }
      >
        {!secondUnit ? (
          <button className="add-unit-product" onClick={onChange}>
            <img className="img-add-unit-product" src={AddUnitPlus} alt="AddUnitPlus" />
            افزودن واحد
          </button>
        ) : null}
      </div>
    </>
  );
};

export const SecondaryUnit = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const updateFlag = useSelector((state) => state).formReducer.updateFlag;
  const defaultValue = input.defaultValue ?? false;

  const [active, setActive] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, updateFlag, editItem]);

  const updateValue = () => {
    const value = findValue(formData, input.formType, input.name, defaultValue);
    setActive(value);
  };

  const renderInputs = () => {
    let formInputs = [];
    input.inputs.map((input, key) => {
      formInputs.push(
        <div
          className={input.wrapperClass ?? "col-lg-12 col-md-12 col-sm-12 col-xs-12"}
          style={input.style ?? null}
        >
          <RenderInput input={input} />
        </div>
      );
    });

    return formInputs;
  };

  const closeSecondaryUnit = () => {
    setActive(false);
    updateInput(dispatch, input.formType, input.name, false, input.primary, !updateFlag);
  };

  return active ? (
    <div className={"col-lg-12 col-md-12 col-sm-12 col-xs-12 secondary-unit-wrapper"}>
      <div className="row secondary-unit-background">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 secondary-unit-close-icon-wrapper">
          <img
            onClick={() => closeSecondaryUnit()}
            className="secondary-unit-close-icon"
            src={CloseIconInputs}
            alt="CloseIconInputs"
          />
        </div>
        {renderInputs()}
      </div>
    </div>
  ) : null;
};

export const CheckBoxInput = (props) => {
  const { input } = props;
  const className = props.className || "";
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const defaultValue = input.defaultValue ?? false;
  const formType = input.formType ?? "forms";
  const onChange = props?.onChange
  const [active, setActive] = useState(defaultValue);
  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  useEffect(() => {
    updateValue();
  }, [formData[formType][input.name]]);
  useEffect(() => {
    setActive(Boolean(defaultValue))

    return () => {

    }
  }, [defaultValue])

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );

    const trueValues = [true, "true", 1, "1"];
    const checked = trueValues.includes(value);

    setActive(checked);
  };

  return (
    <div className={`mx-4 warp-check-box ${className}`}>
      <input
        id={input.name}
        className="form-check-input"
        type="checkbox"
        name={input.name}
        value="1"
        checked={active}
        onChange={() => {
          setActive(!active);
          if (input.name === "removeBranch" && !active) {
            updateInput(dispatch, input.formType, "BranchId", null, input.primary);
            updateInput(dispatch, input.formType, "branch", {}, input.primary);
          }
          updateInput(dispatch, input.formType, input.name, !active, input.primary);
          if (onChange) {
            onChange(!active);
          }
        }}
      />
      <label className="form-check-label" htmlFor={input.name}>
        {input.label + (input.required ? " *" : "")}
      </label>
    </div>
  );
};

export const RadioInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const defaultValue = input.defaultValue ?? input.options[0].value;

  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] ?? defaultValue : defaultValue
    );
    setValue(value);
  };

  const onChange = (value) => {
    setValue(value);
    updateInput(dispatch, input.formType, input.name, value, input.primary);
  };

  return (
    <div className={input.wrapperClass + " " + "style-add-unit" ?? "col-lg-12 col-md-12 col-sm-12 col-xs-12"}>
      <div className="title-radio-input-c">{input.label + (input.required ? " *" : "")}</div>
      <div className="wrap-radio-input-c">
        {input.options.map((item, index) => {
          return (
            <div key={index} className="form-check">
              <label className="form-check-label" for={`${input.name}-${item.value}`}>
                {item.title}
              </label>
              <input
                id={`${input.name}-${item.value}`}
                className="form-check-input"
                type="radio"
                name={input.name}
                value={item.value}
                checked={item.value == value}
                onChange={(e) => onChange(e.target.value)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const DatePickerInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const business = useSelector((state) => state).businessReducer.business
  let isGregorian = business?.business.is_gregorian;
  const { calendar } = useSelector((state) => state).businessReducer.business.business;
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const defaultValue = input.defaultValue ?? momentJalaali();

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setValue(value);
    updateInput(dispatch, input.formType, input.name, value, input.primary);
  };

  return (
    <>
      {!props.reportAction && (
        <label className="labels-new">{input.label + (input.required ? " *" : "")}</label>
      )}
      <div onClick={() => setShowDatePicker(true)} className="warp-date-picker">
        {showDatePicker === true ? (
          <div className="warp-calender">
            <Calendar
              //isGregorian={(calendar && calendar === "میلادی") ? true : false}
              isGregorian={isGregorian}
              onChange={(value) => {
                setValue(value);
                setShowDatePicker(false);
                updateInput(dispatch, input.formType, input.name, value, input.primary);
              }}
            />
          </div>
        ) : (
          ""
        )}
        <div className="show-calender" onClick={() => setShowDatePicker(true)}>
          {/*<div className="title-date-picker">تاریخ</div>*/}
          <div>{secretView ? secretViewValue : formatDate(value, /*calendar && calendar === ""میلادی*/ isGregorian)}</div>
          <img className="img-icon-date-picker" src={imgDatePicker} alt={imgDatePicker} />
        </div>
      </div>
    </>
  );
};

export const CommissionInput = (props) => {
  const { input } = props;
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const defaultValue = input.defaultValue ?? false;

  const [active, setActive] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, [formData.forms.find((form) => form.index === activeIndex)?.others?.haveCommission, editItem]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      "haveCommission",
      editItem ? editItem["haveCommission"] : defaultValue
    );

    const trueValues = [true, "true", 1, "1"];
    const checked = trueValues.includes(value);

    setActive(checked);
  };

  const commissionInput = {
    name: "haveCommission",
    label: "پورسانت",
  };

  const saleCommissionInput = {
    name: "saleCommission",
    label: "درصد از فروش",
    disabled: !active,
  };

  const saleReturnCommissionInput = {
    name: "saleReturnCommission",
    label: "درصد برگشت از فروش",
    disabled: !active,
  };

  const showCommissionInput = {
    active: true,
    name: "showCommissionInFactor",
    type: "status",
    showLabel: false,
    disabled: !active,
  };

  return (
    <div className="row wrap-commission-input">
      <div className="mb-4 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <CheckBoxInput input={commissionInput} />
      </div>
      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
        <PercentInput input={saleCommissionInput} />
      </div>
      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
        <PercentInput input={saleReturnCommissionInput} />
      </div>
      {/* <div
                className="col-lg-3 col-md-3 col-sm-3 col-xs-12 animation"
                style={{color: active ? null : "#797979"}}
            >
                <div className="save-factor-porsant">ثبت پورسانت در فاکتور</div>
                <Status input={showCommissionInput}/>
            </div> */}
    </div>
  );
};

export const PercentInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  let inputValue = "";
  if (formData && formData[input.formType] && formData[input.formType][input.name]) {
    inputValue = formData[input.formType][input.name];
  }
  const defaultValue = null;

  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem, inputValue]);

  useEffect(() => {
    const form = !formData.forms.find((form) => form.index === activeIndex)?.others;
    if (form && !form.haveCommission) {
      onChange(form[input.name]);
    }
  }, [formData.forms.find((form) => form.index === activeIndex)?.others?.haveCommission]);

  const updateValue = () => {
    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setValue(value);
  };

  const onChange = (val) => {
    if (val) {
      const formattedValue = formatNumber(val);
      setValue(formattedValue);
      updateInput(dispatch, input.formType, input.name, val, input.primary);
    } else {
      setValue("");
      updateInput(dispatch, input.formType, input.name, undefined, input.primary);
    }
  };

  return (
    <div className="percent-shareholder">
      <label className={input.disabled ? "disabled-wrap-style" : "wrap-style"}>
        {input.label + (input.required ? " *" : "")}
      </label>
      <div
        className={input.disabled ? "disabled-wrap-style-percent animation" : "wrap-style-percent animation"}
      >
        <input
          type="text"
          value={secretView ? secretViewValue : value}
          maxLength="3"
          onChange={(e) => onChange(e.target.value)}
        />
        %
      </div>
    </div>
  );
};

export const SwitchableTextInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const defaultActive = false;
  const defaultValue = input.defaultValue ?? "";

  const [active, setActive] = useState(defaultActive);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  const updateValue = () => {
    const active = findValue(
      formData,
      input.formType,
      `${input.name}Active`,
      editItem ? editItem[`${input.name}Active`] : defaultValue
    );
    setActive(active);

    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setValue(value);
  };

  const onChange = (value, priceFormat) => {
    if (value.length >= 0) {
      value = formatNumber(value.replaceAll(",", ""));

      if (input.name === "tax") {
        const items = findValue(formData, "factor", "items", null);
        items
          ?.filter((i) => i.product !== undefined)
          .map((i) => {
            i.tax = value;

            let price = i.price;
            let tax = i.price * ((i.tax ?? 0) / 100);
            let discount = i.discountType === "price" ? i.discount ?? 0 : i.price * ((i.discount ?? 0) / 100);

            i.totalPrice = i.quantity * (price + tax - discount);
          });
        updateInput(dispatch, "factor", "items", items, input.primary);
      }

      if (input.name === "discount") {
        const items = findValue(formData, "factor", "items", null);
        items
          ?.filter((i) => i.product !== undefined)
          .map((i) => {
            i.discount = value;
            i.discountType = "percent";

            let price = i.price;
            let tax = i.price * ((i.tax ?? 0) / 100);
            let discount = i.discountType === "price" ? i.discount ?? 0 : i.price * ((i.discount ?? 0) / 100);

            i.totalPrice = i.quantity * (price + tax - discount);
          });
        updateInput(dispatch, "factor", "items", items, input.primary);
      }
    }
    updateInput(dispatch, input.formType, input.name, value, input.primary);
    setValue(value);
  };

  const displayValue = (value, priceFormat) => {
    if (!value) return "";
    return priceFormat ? formatPrice(value) : formatNumber(value);
  };

  const onChangeSwitch = () => {
    if (input.name === "tax" && active) {
      onChange("0");
    }

    if (active) {
      setValue("");
      updateInput(dispatch, input.formType, input.name, defaultValue, input.primary);
    }
    updateInput(dispatch, input.formType, `${input.name}Active`, !active, input.primary);
    setActive(!active);
  };

  return (
    <div className={active ? "active-switch-box-style" : "switch-box-style"}>
      <div className="text-discount">{input.label + (input.required ? " *" : "")}</div>
      <div className={"wrap-style-percent"}>
        {input.isPercentage ? (
          <>
            <input
              type="text"
              maxLength="2"
              value={secretView ? secretViewValue : displayValue(value, false)}
              onChange={(e) => onChange(e.target.value)}
            />
            <div className="perent-text-factor">%</div>
          </>
        ) : (
          <input
            type="text"
            value={secretView ? secretViewValue : displayValue(value, true)}
            onChange={(e) => onChange(e.target.value, true)}
          />
        )}
      </div>

      <div className="switch-security">
        <label className="switch">
          <input type="checkbox" checked={active} onChange={onChangeSwitch} />
          <span className="slider" />
        </label>
      </div>
    </div>
  );
};

export const DescriptionFields = (props) => {
  const { wrapperClass, description } = props.input;
  return (
    <div className="row">
      <p className="description-fields-c">{description}</p>
    </div>
  );
};

export const ButtonInput = ({ input }) => {
  const { width, label, action } = input;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const sendingRequest = useSelector((state) => state).appReducer.sendingRequest;
  const requestingApi = useSelector((state) => state).appReducer.requestingApi;
  const token = useSelector((state) => state).appReducer.token;
  const forms = useSelector((state) => state.formReducer.forms);

  return (
    <div className="row wrap-inputs-btns-c">
      <button
        className="wrap-btns-input"
        type="button"
        style={{ width: width }}
        onClick={() => (action ? dispatch(action(forms, token, input.requestingApi)) : null)}
      >
        <img src={bookMarkFactorWhite} alt="bookMarkFactorWhite" />
        {sendingRequest && input.requestingApi === requestingApi ? (
          <img src={iconLoading} alt="loading" />
        ) : (
          label
        )}
      </button>
    </div>
  );
};

export const ChangePassword = (props) => {
  return (
    <div className="wrap-change-password-c">
      <div className="header-change-password-c">تغییر رمز عبور</div>
      <div className="body-change-password-c">
        <TextInput
          input={{
            isPassword: true,
            name: "oldPassword",
            label: "رمز عبور قدیمی ",
            maxLength: 64,
            primary: true,
          }}
        />
        <TextInput
          input={{
            isPassword: true,
            name: "password",
            label: "رمز عبور جدید ",
            maxLength: 64,
            primary: true,
          }}
        />
        <TextInput
          input={{
            isPassword: true,
            name: "confirmPassword",
            label: "تکرار رمز عبور ",
            maxLength: 64,
            primary: true,
          }}
        />
        <div className="style-c-btns-input">
          <ButtonInput
            input={{
              label: "تغییر رمز عبور",
              requestingApi: "changePassword",
              action: apiChangePassword,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export const ConditionalPriceInput = (props) => {
  const { input } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state).formReducer;
  const editItem = useSelector((state) => state.formReducer.editItem);
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const secretView = useSelector((state) => state.appReducer.secretView);
  const defaultActive = false;
  const defaultValue = input.defaultValue ?? "";

  const [active, setActive] = useState(defaultActive);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  const updateValue = () => {
    const active = findValue(
      formData,
      input.formType,
      `${input.name}Active`,
      editItem ? editItem[`${input.name}Active`] : defaultValue
    );
    setActive(active);

    const value = findValue(
      formData,
      input.formType,
      input.name,
      editItem ? editItem[input.name] : defaultValue
    );
    setValue(value);
  };

  const onChange = (value, priceFormat) => {
    if (value.length >= 0) {
      value = formatNumber(value.replaceAll(",", ""));
    }
    updateInput(dispatch, input.formType, input.name, value, input.primary);
    setValue(value);
  };

  const displayValue = (value, priceFormat) => {
    if (!value) return "";
    return priceFormat ? formatPrice(value) : formatNumber(value);
  };

  const onChangeSwitch = () => {
    onChange("0");
    setValue("");
    updateInput(dispatch, input.formType, input.name, defaultValue, input.primary);
    updateInput(dispatch, input.formType, `${input.name}Active`, !active, input.primary);
    setActive(!active);
  };

  return (
    <div>
      <label className="label-wrap-new-input">{input.label + (input.required ? " *" : "")}</label>
      <div className="wrap-new-input input">
        <input
          className="form-control"
          disabled={input.disabled}
          type="text"
          name="name"
          maxLength={!active ? 12 : 2}
          defaultValue={input.defaultValue}
          value={secretView ? secretViewValue : displayValue(value, true)}
          onChange={(e) => onChange(e.target.value)}
        />
        <button onClick={onChangeSwitch} className="btn-table-add" type="button">
          {!active
            ? formData?.factor?.productCurrency?.en_title ??
            formData?.factor?.factorCurrency?.en_title ??
            getCurrency().defCur.en_title
            : "%"}
        </button>
      </div>
    </div>
  );
};
